angular.module('impactx.user')
    .directive('ixReferenceUser', ['$context', function ($context) {
        return {
            scope: {
                data: "=",
                useContactDialog: "="
            },
            controller: 'IxReferenceUserController',
            controllerAs: 'referenceUserController',
            restrict: 'E',
            templateUrl: "shared/user/templates/referenceuser.tmpl.html",
            transclude: true,
            link: function (scope) {
                scope.contextUserId = $context.userId.value;
            }
        };
    }]);